/** Facts about GA4 and about the tag itself, shared by the units below. */

/** GA4 measurement ids look like `G-Y2TNQWSGE4`. */
export const MEASUREMENT_ID_PATTERN = /^G-[A-Z0-9]{4,}$/i;

/** GA4 caps: 40 chars for an event name or parameter key, 100 for a value, 25 parameters. */
export const MAX_NAME_LENGTH = 40;
export const MAX_VALUE_LENGTH = 100;
export const MAX_PARAMS = 25;

export const TAG_ELEMENT_ID = 'ga4-gtag';
export const TAG_ORIGIN = 'https://www.googletagmanager.com/gtag/js';

/** How long the idle-time tag load may be deferred before it happens anyway. */
export const DEFAULT_LOAD_TIMEOUT_MS = 3_000;

/** Stand-in for anything that was scrubbed out of a value. */
export const REDACTED = '[redacted]';
